import * as _ from 'lodash';
import {
    lifeCycleStatusLookup,
    nationalPopularityCodeLookup,
} from 'shared/product/product-lookups';


// Ordered list according on SPD2-2460
export const availableColumnsList: any = [
    {
        option: 'photo',
        title: 'Primary Photo (thumbnail)',
        column_name: 'photo',
        title_column_name: 'Primary',
        sortable: false,
        type: 'image',
        link: true,
        cssWidth: '93px',
    },
    {
        option: 'partNumber',
        title: 'Part no.',
        column_name: 'partNumber',
        title_column_name: 'Part no.',
        field_name: 'partNumber',
        sortable: true,
        truncate: true,
        link: true,
        data: (row: any) => {
            return _.get(row, 'partNumber');
        },
        cssWidth: '10%',
    },
    {
        option: 'partTerminology',
        title: 'Part type',
        column_name: 'partTerminology',
        title_column_name: 'Part type',
        field_name: 'details.partTerminology.name',
        sortable: true,
        data: (row: any) => {
            return _.get(row, 'details.partTerminology.name', _.get(row, 'partTerminology.name', ''));
        },
        cssWidth: '15%',
    },
    {
        option: 'gtin',
        title: 'GTIN (14)',
        column_name: 'gtin',
        title_column_name: 'GTIN',
        field_name: 'details.gtin',
        sortable: false,
        truncate: false,
        cssWidth: '8%',
        data: (row: any) => {
            return _.get(row, 'details.gtin', '');
        }
    },
    {
        option: 'gtin-upc',
        title: 'GTIN UPC',
        column_name: 'gtin-upc',
        title_column_name: 'UPC',
        field_name: 'details.gtinQualifier',
        sortable: false,
        truncate: false,
        cssWidth: '8%',
        data: (row: any) => {
            return _.get(row, 'details.gtinQualifier', '');
        }
    },
    {
        option: 'harmonized-tariff',
        title: 'Canadian tariff (HAC)',
        column_name: 'harmonized-tariff',
        title_column_name: 'HAC',
        field_name: 'extendedInformation.HAC.EN',
        sortable: false,
        truncate: false,
        cssWidth: '8%',
        data: (row: any) => {
            return _.get(row, 'extendedInformation.HAC.EN', '');
        }
    },
    {
        option: 'harmonized-tariff-hts',
        title: 'Harmonized tariff (HTS)',
        column_name: 'harmonized-tariff-hts',
        title_column_name: 'HTS',
        field_name: 'extendedInformation.HTS.EN',
        sortable: false,
        truncate: false,
        cssWidth: '8%',
        data: (row: any) => {
            return _.get(row, 'extendedInformation.HTS.EN', '');
        }
    },
    {
        option: 'harmonized-tariff-htb',
        title: 'Harmonized tariff (HTB)',
        column_name: 'harmonized-tariff-htb',
        title_column_name: 'HTB',
        field_name: 'extendedInformation.HSB.EN',
        sortable: false,
        truncate: false,
        cssWidth: '8%',
        data: (row: any) => {
            return _.get(row, 'extendedInformation.HSB.EN', '');
        }
    },
    {
        option: 'hazardous',
        title: 'Hazardous (Y/N)',
        column_name: 'hazardous',
        title_column_name: 'Hazard',
        field_name: 'extendedInformation.MSR.EN',
        sortable: false,
        truncate: false,
        cssWidth: '5%',
        data: (row: any) => {
            return _.get(row, 'extendedInformation.MSR.EN', '');
        }
    },
    {
        option: 'lifeCycleStatus',
        title: 'Life сycle status',
        column_name: 'lifeCycleStatus',
        title_column_name: 'Life cycle',
        field_name: 'details.lifeCycleStatus',
        sortable: true,
        cssWidth: '10%',
        data: (row: any) => {
            const option = _.get(row, 'details.lifeCycleStatus');
            const item = _.find(lifeCycleStatusLookup, {option});
            return item && item.title ? item.title : null;
        }
    },
    {
        option: 'nationalPopularityCode',
        title: 'National popularity code',
        column_name: 'nationalPopularityCode',
        title_column_name: 'NPC',
        field_name: 'details.nationalPopularityCode',
        sortable: true,
        truncate: true,
        cssWidth: '10%',
        data: (row: any) => {
            const option = _.get(row, 'details.nationalPopularityCode');
            const item = _.find(nationalPopularityCodeLookup, {option});
            return item && item.title ? item.title : null;
        }
    },
    {
        option: 'item-quantity',
        title: 'Item quantity',
        column_name: 'item-quantity',
        title_column_name: 'Qty',
        field_name: 'details.itemQuantity',
        sortable: false,
        truncate: false,
        cssWidth: '5%',
        data: (row: any) => {
            return _.get(row, 'details.itemQuantity', '') + ' ' + _.get(row, 'details.itemQuantityUomTitle', '');
        }
    },
    {
        option: 'item_quantity_per_application',
        title: 'Item quantity per application',
        column_name: 'item_quantity_per_application',
        title_column_name: 'Qty app',
        field_name: 'details.quantityPerApplication',
        truncate: true,
        sortable: true,
        cssWidth: '5%',
        data: (row: any) => {
            return _.get(row, 'details.quantityPerApplication', '');
        }
    },
    {
        option: 'minimum_order_quantity',
        title: 'Minimum order quantity',
        column_name: 'minimum_order_quantity',
        title_column_name: 'Qty min',
        field_name: 'details.minimumOrderQuantity',
        truncate: true,
        sortable: true,
        cssWidth: '5%',
        data: (row: any) => {
            const value = _.get(row, 'details.minimumOrderQuantity', '');
            if (value) {
                return value + ' ' + _.get(row, 'details.minimumOrderQuantityUom', '');
            } else {
                return value;
            }
        }
    },
    {
        option: 'group',
        title: 'Group',
        column_name: 'group',
        title_column_name: 'Group',
        field_name: 'details.group',
        sortable: true,
        cssWidth: '10%',
        data: (row: any) => {
            const group = _.get(row, 'details.group');
            if (group) {
                let res = '';
                if (group.name) { res = group.name; }
                if (group.code) { res = `${res}(${group.code})`; }
                return res;
            } else {
                return null;
            }
        }
    },
    {
        option: 'subgroup',
        title: 'Sub group',
        column_name: 'subgroup',
        title_column_name: 'Subgroup',
        field_name: 'details.group.subGroup',
        sortable: true,
        cssWidth: '10%',
        data: (row: any) => {
            const group = _.get(row, 'details.group');
            if (group && group.subGroup) {
                let res = '';
                if (group.subGroup.name) { res = group.subGroup.name; }
                if (group.subGroup.code) { res = `${res}(${group.subGroup.code})`; }
                return res;
            } else {
                return null;
            }
        }
    },
    {
        option: 'description_sho_en',
        title: 'Short description',
        column_name: 'description_sho_en',
        title_column_name: 'Short',
        field_name: 'descriptions.SHO.EN',
        truncate: true,
        sortable: true,
        data: (row: any) => {
            return _.get(row, 'descriptions.SHO.EN', '');
        }
    },
    {
        option: 'description_des_en',
        title: 'Long description',
        column_name: 'description_des_en',
        title_column_name: 'Long',
        field_name: 'descriptions.DES.EN',
        truncate: true,
        sortable: true,
        data: (row: any) => {
            return _.get(row, 'descriptions.DES.EN', '');
        }
    },
    {
        option: 'description_ext_en',
        title: 'Extended Description',
        column_name: 'description_ext_en',
        title_column_name: 'Ext',
        field_name: 'description_ext_en',
        truncate: true,
        sortable: true,
        data: (row: any) => {
            return _.get(row, 'description_ext_en', '');
        }
    },
    {
        option: 'description_asm_en',
        title: 'Application summary',
        column_name: 'description_asm_en',
        title_column_name: 'App Sum',
        field_name: 'descriptions.ASM.EN',
        truncate: true,
        sortable: true,
        data: (row: any) => {
            return _.get(row, 'descriptions.ASM.EN', '');
        }
    },
    {
        option: 'description_asc_en',
        title: 'Associated comments',
        column_name: 'description_asc_en',
        title_column_name: 'Associated',
        field_name: 'description_asc_en',
        truncate: true,
        sortable: true,
        data: (row: any) => {
            return _.get(row, 'description_asc_en', '');
        }
    },
    {
        option: 'description_mkt_en',
        title: 'Marketing Description',
        column_name: 'description_mkt_en',
        title_column_name: 'Marketing',
        field_name: 'description_mkt_en',
        truncate: true,
        sortable: true,
        data: (row: any) => {
            return _.get(row, 'description_mkt_en', '');
        }
    },
    {
        option: 'description_fab_en',
        title: 'Features and Benefits',
        column_name: 'description_fab_en',
        title_column_name: 'F&B',
        field_name: 'description_fab_en',
        truncate: true,
        sortable: true,
        data: (row: any) => {
            return _.get(row, 'description_asc_en', '');
        }
    },
    {
        option: 'description_key_en',
        title: 'Keywords',
        column_name: 'description_key_en',
        title_column_name: 'Keywords',
        field_name: 'description_key_en',
        truncate: true,
        sortable: true,
        data: (row: any) => {
            return _.get(row, 'description_key_en', '');
        }
    },
    {
        option: 'digital_assets_file_names',
        title: 'Digital assets (name)',
        column_name: 'digital_assets_file_names',
        title_column_name: 'Asset name',
        field_name: 'digital_assets_file_names',
        truncate: true,
        sortable: true,
        data: (row: any) => {
            return _.get(row, 'digital_assets_file_names', '');
        }
    },
    {
        option: 'digital_assets_file_urls',
        title: 'Digital assets (URL)',
        column_name: 'digital_assets_file_urls',
        title_column_name: 'Asset URL',
        field_name: 'digital_assets_file_urls',
        truncate: true,
        sortable: true,
        data: (row: any) => {
            return _.get(row, 'digital_assets_file_urls', '');
        }
    },
    {
        option: 'attributes',
        title: 'Attributes',
        column_name: 'attributes',
        title_column_name: 'Attributes',
        field_name: 'attributes_list',
        truncate: true,
        sortable: true,
        data: (row: any) => {
            return _.get(row, 'attributes_list', '');
        }
    },
    {
        option: 'C_A_R_B_E_O_Number',
        title: 'C.A.R.B. E.O. Number',
        column_name: 'C_A_R_B_E_O_Number',
        title_column_name: 'EO #',
        field_name: 'C_A_R_B_E_O_Number',
        sortable: false,
        truncate: false,
        cssWidth: '10%',
        data: (row: any) => {
            return _.get(row, 'C_A_R_B_E_O_Number', '');
        }
    },
    {
        option: 'california_proposition_65',
        title: 'California Proposition 65',
        column_name: 'california_proposition_65',
        title_column_name: 'Prop 65',
        field_name: 'california_proposition_65',
        sortable: false,
        truncate: false,
        cssWidth: '10%',
        data: (row: any) => {
            return _.get(row, 'california_proposition_65', '');
        }
    },
    {
        option: 'price_retail_1_usd',
        title: 'Retail price (1)',
        column_name: 'price_retail_1_usd',
        title_column_name: 'Ret 1',
        field_name: 'price_retailer_1.USD',
        sortable: true,
        cssWidth: '110px',
        type: 'currency',
        data: (row: any) => {
            return _.get(row, 'price_retailer_1.USD', '');
        }
    },
    {
        option: 'price_jobber_1_usd',
        title: 'Jobber price (1)',
        column_name: 'price_jobber_1_usd',
        title_column_name: 'Jobr 1',
        field_name: 'price_jobber_1.USD',
        sortable: true,
        type: 'currency',
        cssWidth: '110px',
        data: (row: any) => {
            return _.get(row, 'price_jobber_1.USD', '');
        }
    },
    {
        option: 'map-price',
        title: 'Map Price (1)',
        column_name: 'map-price',
        title_column_name: 'MAP 1',
        field_name: 'price_map_1.USD',
        sortable: false,
        truncate: false,
        type: 'currency',
        cssWidth: '110px',
        data: (row: any) => {
            return _.get(row, 'price_map_1.USD', '');
        }
    },
    {
        option: 'dealer-price',
        title: 'Dealer Price (1)',
        column_name: 'dealer-price',
        title_column_name: 'Dealr 1',
        field_name: 'price_dealer_1.USD',
        sortable: false,
        truncate: false,
        type: 'currency',
        cssWidth: '110px',
        data: (row: any) => {
            return _.get(row, 'price_dealer_1.USD', '');
        }
    },
    {
        option: 'list-price',
        title: 'List Price (1)',
        column_name: 'list-price',
        title_column_name: 'List 1',
        field_name: 'price_list_1.USD',
        sortable: false,
        truncate: false,
        type: 'currency',
        cssWidth: '110px',
        data: (row: any) => {
            return _.get(row, 'price_list_1.USD', '');
        }
    },
    {
        option: 'price_retail_2_usd',
        title: 'Retail price (2)',
        column_name: 'price_retail_2_usd',
        title_column_name: 'Ret 2',
        field_name: 'price_retailer_2.USD',
        sortable: true,
        cssWidth: '110px',
        type: 'currency',
        data: (row: any) => {
            return _.get(row, 'price_retailer_2.USD', '');
        }
    },
    {
        option: 'price_jobber_2_usd',
        title: 'Jobber price (2)',
        column_name: 'price_jobber_2_usd',
        title_column_name: 'Jobr 2',
        field_name: 'price_jobber_2.USD',
        sortable: true,
        type: 'currency',
        cssWidth: '110px',
        data: (row: any) => {
            return _.get(row, 'price_jobber_2.USD', '');
        }
    },
    {
        option: 'map-price-2',
        title: 'Map Price (2)',
        column_name: 'map-price-2',
        title_column_name: 'MAP 2',
        field_name: 'price_map_2.USD',
        sortable: false,
        truncate: false,
        type: 'currency',
        cssWidth: '110px',
        data: (row: any) => {
            return _.get(row, 'price_map_2.USD', '');
        }
    },
    {
        option: 'dealer-price-2',
        title: 'Dealer Price (2)',
        column_name: 'dealer-price-2',
        title_column_name: 'Dealr 2',
        field_name: 'price_dealer_2.USD',
        sortable: false,
        truncate: false,
        type: 'currency',
        cssWidth: '110px',
        data: (row: any) => {
            return _.get(row, 'price_dealer_2.USD', '');
        }
    },
    {
        option: 'list-price-2',
        title: 'List Price (2)',
        column_name: 'list-price-2',
        title_column_name: 'List 2',
        field_name: 'price_list_2.USD',
        sortable: false,
        truncate: false,
        type: 'currency',
        cssWidth: '110px',
        data: (row: any) => {
            return _.get(row, 'price_list_2.USD', '');
        }
    },
    {
        option: 'package-length-inches',
        title: 'Package Length (inches)',
        column_name: 'package-length-inches',
        title_column_name: 'L',
        field_name: 'packages.EA.dimensions.length',
        sortable: false,
        truncate: false,
        cssWidth: '5%',
        data: (row: any) => {
            return _.get(row, 'packages.EA.dimensions.length', '');
        }
    },
    {
        option: 'package-width-inches',
        title: 'Package Width (inches)',
        column_name: 'package-width-inches',
        title_column_name: 'W',
        field_name: 'packages.EA.dimensions.width',
        sortable: false,
        truncate: false,
        cssWidth: '5%',
        data: (row: any) => {
            return _.get(row, 'packages.EA.dimensions.width', '');
        }
    },
    {
        option: 'package-height-inches',
        title: 'Package Height (inches)',
        column_name: 'package-height-inches',
        title_column_name: 'H',
        field_name: 'packages.EA.dimensions.height',
        sortable: false,
        truncate: false,
        cssWidth: '5%',
        data: (row: any) => {
            return _.get(row, 'packages.EA.dimensions.height', '');
        }
    },
    {
        option: 'weight',
        title: 'Weight',
        column_name: 'weight',
        title_column_name: 'Wt',
        field_name: 'packages.EA.weights.weight',
        sortable: false,
        truncate: false,
        cssWidth: '5%',
        data: (row: any) => {
            const value = _.get(row, 'packages.EA.weights.weight', '');
            if (value) {
                return value + ' lbs';
            } else {
                return value;
            }
        }
    },
    {
        option: 'inner_quantity',
        title: 'Inner quantity',
        column_name: 'inner_quantity',
        title_column_name: 'Inner Qty',
        field_name: 'packages.EA.inner_quantity',
        truncate: true,
        sortable: true,
        data: (row: any) => {
            const value = _.get(row, 'packages.EA.inner_quantity', '');
            if (value) {
                return value + ' ' + _.get(row, 'packages.EA.inner_quantity_uom', '');
            } else {
                return value;
            }
        }
    },
    {
        option: 'bar_code',
        title: 'Barcode',
        column_name: 'bar_code',
        title_column_name: 'Barcode',
        field_name: 'packages.EA.package_bar_code_characters',
        truncate: true,
        sortable: true,
        data: (row: any) => {
            return _.get(row, 'packages.EA.package_bar_code_characters', '');
        }
    },
    {
        option: 'orderable',
        title: 'Orderable (Y/N)',
        column_name: 'orderable',
        title_column_name: 'Ord',
        field_name: 'packages.EA.orderable',
        truncate: true,
        sortable: true,
        data: (row: any) => {
            return _.get(row, 'packages.EA.orderable', '');
        }
    },
    {
        option: 'country-of-origin',
        title: 'Country Of Origin',
        column_name: 'country-of-origin',
        title_column_name: 'Org',
        field_name: 'extendedInformation.CTO.EN',
        sortable: false,
        truncate: false,
        cssWidth: '5%',
        data: (row: any) => {
            return _.get(row, 'extendedInformation.CTO.EN', '');
        }
    },
    {
        option: 'created_at',
        title: 'Created date',
        column_name: 'created_at',
        title_column_name: 'Created',
        field_name: 'created_at',
        sortable: true,
        type: 'date',
        cssWidth: '110px',
    },
    {
        option: 'updated_at',
        title: 'Last modified date',
        column_name: 'updated_at',
        field_name: 'updated_at',
        title_column_name: 'Modified',
        sortable: true,
        type: 'date',
        cssWidth: '110px',
    },
    {
        option: 'last_published_at',
        title: 'Last published date',
        column_name: 'last_published_at',
        title_column_name: 'Published',
        field_name: 'last_published_at',
        sortable: true,
        type: 'date',
        cssWidth: '140px',
    },
    {
        option: 'fitments',
        title: 'Fitments',
        column_name: 'fitments',
        title_column_name: 'Fitments',
        field_name: 'fitments',
        sortable: true,
        link: true,
        linkEmptyUnderlineOnHover: true,
        permissions: ['admin', 'fitments'],
        cssWidth: '90px',
    },
    // segment scores
    {
        option: 'detail_score',
        title: 'Score - Detail',
        column_name: 'detail_score',
        title_column_name: 'Detail',
        field_name: 'detail_score',
        sortable: true,
        cssWidth: '6%',
        type: 'score',
    },
    {
        option: 'description_score',
        title: 'Score - Description',
        column_name: 'description_score',
        title_column_name: 'Description',
        field_name: 'description_score',
        sortable: true,
        cssWidth: '10%',
        type: 'score',
    },
    {
        option: 'fitment_score',
        title: 'Score - Fitment',
        column_name: 'fitment_score',
        title_column_name: 'Fitment',
        field_name: 'fitment_score',
        sortable: true,
        cssWidth: '8%',
        type: 'score',
    },
    {
        option: 'pricing_score',
        title: 'Score - Pricing',
        column_name: 'pricing_score',
        title_column_name: 'Pricing',
        field_name: 'pricing_score',
        sortable: true,
        cssWidth: '7%',
        type: 'score',
    },
    {
        option: 'digital_assets_score',
        title: 'Score - Digital Assets',
        column_name: 'digital_assets_score',
        title_column_name: 'Assets',
        field_name: 'digital_assets_score',
        sortable: true,
        cssWidth: '10%',
        type: 'score',
    },
    {
        option: 'attributes_score',
        title: 'Score - Attributes',
        column_name: 'attributes_score',
        title_column_name: 'Attributes',
        field_name: 'attributes_score',
        sortable: true,
        cssWidth: '8%',
        type: 'score',
    },
    {
        option: 'packaging_score',
        title: 'Score - Packaging',
        column_name: 'packaging_score',
        title_column_name: 'Packaging',
        field_name: 'packaging_score',
        sortable: true,
        cssWidth: '9%',
        type: 'score',
    },
    {
        option: 'kits_score',
        title: 'Score - Kits',
        column_name: 'kits_score',
        title_column_name: 'Kits',
        field_name: 'kits_score',
        sortable: true,
        cssWidth: '6%',
        type: 'score',
    },
    {
        option: 'interchange_score',
        title: 'Score - Interchange',
        column_name: 'interchange_score',
        title_column_name: 'Interchange',
        field_name: 'interchange_score',
        sortable: true,
        cssWidth: '10%',
        type: 'score',
    },
    // segment scores end
    {
        option: 'score',
        title: 'Score - Overall',
        column_name: 'score',
        title_column_name: 'Overall',
        field_name: 'score',
        sortable: true,
        cssWidth: '50px',
        type: 'score',
    },
];
